class Header {
    constructor() {
        this.timer = '';
        this.header = document.querySelector('[data-header]');
        this.headerOuter = document.querySelector('[data-header-outer]');
        this.headerTop = document.querySelector('[data-header-top]');
        this.headerMenu = document.querySelector('[data-header-menu]');
        this.menuLinks = document.querySelectorAll('[data-menu-link]');
        this.closers = document.querySelectorAll('[data-closer]');
        this.list = document.querySelector('[data-categories-list]');
        this.body = document.querySelector('body');
        this.hamburger = document.querySelector('[data-header-hamburger]');
        this.mainMenu = document.querySelector('[data-main-menu]');
        this.mainMenuCloser = document.querySelector('[data-main-menu-closer]');

        this.mobileSearcher = this.header.querySelector('[data-mobile-search]');

        this.mainMenuOpened = false;

        this.timer = null;
        this.mouseX = 0;
        this.lastScroll = 0;
        this.init();
    }

    init() {
        if (this.menuLinks.length && this.headerMenu) {
            this.initOpen();
        }

        if (this.closers) {
            this.initClosers();
        }

        this.heightCheck();
        this.initCategoriesLinks();
        this.initSubcategoriesList();
        this.initSticky();
        // this.initMobileSearcher();
    }

    initMobileSearcher() {
        if (this.mobileSearcher) {
            const instance = this;
            const opener = this.mobileSearcher.querySelector('[data-mobile-search-opener]');
            const closer = this.mobileSearcher.querySelector('[data-mobile-search-closer]');

            opener.addEventListener('click', (e) => {
                e.preventDefault();
                instance.mobileSearcher.classList.add('_opened');
            });
            closer.addEventListener('click', (e) => {
                e.preventDefault();
                instance.mobileSearcher.classList.remove('_opened');
            });
        }
    }

    initSticky() {
        const instance = this;
        this.headerHeight = this.header.offsetHeight;
        this.headerTopHeight = this.headerTop.offsetHeight;

        document.addEventListener('scroll', () => {
            const scrollTop = window.pageYOffset;
            if (scrollTop > 0) {
                this.header.classList.add('_sticky');
            } else {
                instance.header.classList.remove('_sticky');
            }

            if (!this.headerTopHeight) {
                return;
            }

            if (scrollTop < this.lastScroll) {
                if (scrollTop > this.headerTopHeight) {
                    document.dispatchEvent(new Event('ToBigHeader'));
                    this.header.classList.add('_up');
                    this.headerOuter.style.transition = 'transform .3s linear';
                    this.headerOuter.style.transform = 'translate3d(0, 0, 0)';
                } else if (scrollTop <= this.headerTopHeight) {
                    if (!this.header.classList.contains('_up')) {
                        this.headerOuter.style.transition = '';
                        this.headerOuter.style.transform = `translate3d(0, -${scrollTop}px, 0)`;
                    }
                }
            } else {
                document.dispatchEvent(new Event('ToSmallHeader'));
                this.header.classList.remove('_up');
                const maxOffset = scrollTop > this.headerTopHeight ? this.headerTopHeight : scrollTop;

                if (scrollTop <= this.headerHeight) {
                    // скролтоп в зоне высоты шапки
                    this.headerOuter.style.transform = `translate3d(0, -${maxOffset}px, 0)`;
                    this.headerOuter.style.transition = '';
                } else {
                    // скролтоп ниже высоты шапки
                    this.headerOuter.style.transform = `translate3d(0, -${maxOffset}px, 0)`;
                    this.headerOuter.style.transition = 'transform .3s linear';
                }
            }

            this.lastScroll = scrollTop;
        });
    }

    initOpen() {
        this.menuLinks.forEach((link) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                this.headerMenu.classList.add('_opened');
                this.body.classList.add('_fixed');
            });
        })


        this.hamburger.addEventListener('click', (e) => {
            e.preventDefault();
            this.mainMenu.classList.add('_opened');
            this.body.classList.add('_fixed');
            this.mainMenuOpened = true;
        });
    }

    initClosers() {
        this.closers.forEach((e) => {
            e.addEventListener('click', () => {
                this.headerMenu.classList.remove('_opened');
                if (!this.mainMenuOpened) {
                    this.body.classList.remove('_fixed');
                }
            })
        });

        this.mainMenuCloser.addEventListener('click',(e) => {
            e.preventDefault();
            this.mainMenuOpened = false;
            this.mainMenu.classList.remove('_opened');
            this.body.classList.remove('_fixed');
        })
    }

    heightCheck() {
        const listHeight = this.list.scrollHeight;
        // Если высота списка + паддинги меньше чем высота экрана то скрываем скролбар
        if ((listHeight + 126) < window.innerHeight) {
            this.list.classList.add('_scrollbar-hide')
        }
    }

    initCategoriesLinks() {
        const links = this.list.querySelectorAll('li');
        links.forEach((item) => {
            item.addEventListener('mouseenter', () => {
                this.debounce(() => {
                    links.forEach((link) => {
                        link.classList.remove('_opened');
                    })
                    item.classList.add('_opened');
                }, 400);
            })
        })
    }

    initSubcategoriesList() {
        this.list.querySelectorAll('[data-sub-menu]').forEach((item) => {
            item.addEventListener('mouseenter', () => {
                clearTimeout(this.timer);
            });
        })
    }


    debounce( callback, delay ) {
        if (this.timer) {
            clearTimeout( this.timer );
        }
        this.timer = setTimeout( callback, delay );
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new Header();
});